import { SwitchProps } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

import { HBSwitchRootStyle } from './HBSwitch.styles';

export interface HBSwitchProps extends Omit<SwitchProps, 'ref'> {
  disabled?: boolean;
  checked?: boolean;
  checkedColor?: string;
  uncheckedColor?: string;
  disabledColor?: string;
  dataTestId?: string;
}

export const HBSwitch = forwardRef(
  <T extends HTMLButtonElement>(props: HBSwitchProps, ref: ForwardedRef<T>) => {
    const { inputProps, dataTestId, ...rest } = props;

    const testInputProps = {
      'data-test-id': `${dataTestId}-switch`,
    };

    return (
      <HBSwitchRootStyle
        inputProps={{
          ...inputProps,
          ...testInputProps,
        }}
        ref={ref}
        {...rest}
      />
    );
  },
);

HBSwitch.displayName = 'HBSwitch';
